import React from 'react';
import styled from 'styled-components';
import Button from '../../components/ui/Button';
import { StartScreenProps } from '../../types';

const StartContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 4rem 2.4rem;
  position: relative;

  &::after {
    content: '✦';
    font-size: 2rem;
    color: var(--color-theme);
    position: absolute;
    bottom: 1rem;
    opacity: 0.5;
  }
`;

const Title = styled.h2`
  font-size: 4rem;
  margin-bottom: 2.4rem;
  color: var(--color-theme);
  font-family: var(--font-secondary);
  font-weight: 500;
  letter-spacing: 1px;
  line-height: 1.2;

  &::before, &::after {
    content: '';
    display: block;
    width: 80px;
    height: 2px;
    background-color: var(--color-theme);
    margin: 2rem auto;
    opacity: 0.6;
  }

    @media (max-width: 768px) {
        font-size: 2.5rem;
    }
`;

const Subtitle = styled.h3`
  font-size: 2rem;
  margin-bottom: 4.8rem;
  color: var(--color-darkest);
  font-family: var(--font-secondary);
  font-weight: 400;
  max-width: 80%;
  line-height: 1.4;
`;

const Logo = styled.img`
    width: 100%;
    max-width: 50%;
    height: auto;
    object-fit: cover;

  @media (max-width: 768px) {
      max-width: 50vw;
  }
`;

const StartScreen: React.FC<StartScreenProps> = ({ numQuestions, onStart }) => {
  return (
    <StartContainer>
      <Logo src={`${process.env.PUBLIC_URL}/logo.png`} alt="Quiz App Logo" />

      <Title>POMENUJTE ŠTÝL,<br />KTORÝ VÁS VYSTIHUJE</Title>
      <Subtitle>{numQuestions} otázok, ktoré odhalia štýl Vašich šperkov</Subtitle>

      <Button $primary onClick={onStart}>
        Poďme na to!
      </Button>
    </StartContainer>
  );
};

export default StartScreen;
